import DataService from "../Dataservice";

const getMyBussiness = async () => {
  let url = "/business/my_business/";
  const data = await DataService.get(url);
  return data?.data;
};

const addBusiness = async (values) => {
  let url = "/business/create/";
  const data = await DataService.post(url, values);
  return data?.data;
};

const getBusinessDetails = async (id) => {
  let url = `/business/my_business/${id}/`;
  const data = await DataService.get(url);
  return data?.data;
};

const deleteBusiness = async (id) => {
  let url = `/business/my_business/${id}/`;
  const data = await DataService.del(url);
  return data?.data;
};

const editBussiness = async (values) => {
  const { id, ...editData } = values;
  let url = `/business/my_business/${id}/`;
  const data = await DataService.patch(url, editData);
  return data?.data;
};

const getSubcriptionPlan = async (id) => {
  let url = `/business/my_business/${id}/subscription_plans/`;
  const data = await DataService.get(url);
  return data?.data;
};

const getCurrentPlan = async (id) => {
  let url = `/business/my_business/${id}/current_plan/`;
  const data = await DataService.get(url);
  return data?.data;
};

const getBusinessList = async ({
  latitude,
  longitude,
  radius,
  category,
  subCategory,
  name,
  is_premium,
  is_pro,
  limit,
  offset,
}) => {
  console.log('🔗 Business URL Parameters:', {
    latitude,
    longitude,
    radius,
    category,
    subCategory,
    name,
    is_premium,
    limit,
    offset
  });
  
  let url = "";
  if (
    latitude &&
    longitude &&
    category &&
    subCategory &&
    radius &&
    name &&
    limit &&
    is_premium !== undefined
  ) {
    url = `/business/list/?lat=${latitude}&lon=${longitude}&category=${category}&sub_category=${subCategory}&radius=${radius}&name=${name}&is_premium=${is_premium}&limit=${limit}&offset=${offset}`;
    console.log('🎯 Using condition 1:', url);
  } else if (
    latitude &&
    longitude &&
    category &&
    subCategory &&
    radius &&
    limit &&
    is_premium !== undefined
  ) {
    url = `/business/list/?lat=${latitude}&lon=${longitude}&category=${category}&sub_category=${subCategory}&radius=${radius}&is_premium=${is_premium}&limit=${limit}&offset=${offset}`;
    console.log('🎯 Using condition 2:', url);
  } else if (latitude && longitude && radius && subCategory && name && limit && is_premium !== undefined) {
    url = `/business/list/?lat=${latitude}&lon=${longitude}&radius=${radius}&name=${name}&sub_category=${subCategory}&is_premium=${is_premium}&limit=${limit}&offset=${offset}`;
    console.log('🎯 Using condition 3:', url);
  } else if (latitude && longitude && radius && subCategory && limit && is_premium !== undefined) {
    url = `/business/list/?lat=${latitude}&lon=${longitude}&radius=${radius}&sub_category=${subCategory}&is_premium=${is_premium}&limit=${limit}&offset=${offset}`;
    console.log('🎯 Using condition 4:', url);
  } else if (latitude && longitude && radius && name && limit && is_premium !== undefined) {
    url = `/business/list/?lat=${latitude}&lon=${longitude}&radius=${radius}&name=${name}&is_premium=${is_premium}&limit=${limit}&offset=${offset}`;
    console.log('🎯 Using condition 5:', url);
  } else if (latitude && longitude && radius && limit && is_premium !== undefined) {
    url = `/business/list/?lat=${latitude}&lon=${longitude}&radius=${radius}&is_premium=${is_premium}&limit=${limit}&offset=${offset}`;
    console.log('🎯 Using condition 6:', url);
  } else if (
    latitude &&
    longitude &&
    category &&
    subCategory &&
    radius &&
    name &&
    limit
  ) {
    // New condition without is_premium filter - gets all businesses
    url = `/business/list/?lat=${latitude}&lon=${longitude}&category=${category}&sub_category=${subCategory}&radius=${radius}&name=${name}&limit=${limit}&offset=${offset}`;
    console.log('🎯 Using condition 7 (all businesses):', url);
  } else if (
    latitude &&
    longitude &&
    category &&
    subCategory &&
    radius &&
    limit
  ) {
    // New condition without is_premium filter - gets all businesses
    url = `/business/list/?lat=${latitude}&lon=${longitude}&category=${category}&sub_category=${subCategory}&radius=${radius}&limit=${limit}&offset=${offset}`;
    console.log('🎯 Using condition 8 (all businesses):', url);
  } else if (latitude && longitude && radius && subCategory && name && limit) {
    // New condition without is_premium filter - gets all businesses
    url = `/business/list/?lat=${latitude}&lon=${longitude}&radius=${radius}&name=${name}&sub_category=${subCategory}&limit=${limit}&offset=${offset}`;
    console.log('🎯 Using condition 9 (all businesses):', url);
  } else if (latitude && longitude && radius && subCategory && limit) {
    // New condition without is_premium filter - gets all businesses
    url = `/business/list/?lat=${latitude}&lon=${longitude}&radius=${radius}&sub_category=${subCategory}&limit=${limit}&offset=${offset}`;
    console.log('🎯 Using condition 10 (all businesses):', url);
  } else if (latitude && longitude && radius && name && limit) {
    // New condition without is_premium filter - gets all businesses
    url = `/business/list/?lat=${latitude}&lon=${longitude}&radius=${radius}&name=${name}&limit=${limit}&offset=${offset}`;
    console.log('🎯 Using condition 11 (all businesses):', url);
  } else if (latitude && longitude && radius && limit) {
    // New condition without is_premium filter - gets all businesses
    url = `/business/list/?lat=${latitude}&lon=${longitude}&radius=${radius}&limit=${limit}&offset=${offset}`;
    console.log('🎯 Using condition 12 (all businesses):', url);
  } else if (category && subCategory && name && limit) {
    // No location — filter by category + subcategory + name
    url = `/business/list/?category=${category}&sub_category=${subCategory}&name=${name}&limit=${limit}&offset=${offset}`;
    console.log('🎯 Using condition 13 (no location, cat+subcat+name):', url);
  } else if (category && subCategory && limit) {
    // No location — filter by category + subcategory
    url = `/business/list/?category=${category}&sub_category=${subCategory}&limit=${limit}&offset=${offset}`;
    console.log('🎯 Using condition 14 (no location, cat+subcat):', url);
  } else if (subCategory && name && limit) {
    // No location — filter by subcategory + name
    url = `/business/list/?sub_category=${subCategory}&name=${name}&limit=${limit}&offset=${offset}`;
    console.log('🎯 Using condition 15 (no location, subcat+name):', url);
  } else if (subCategory && limit) {
    // No location — filter by subcategory only
    url = `/business/list/?sub_category=${subCategory}&limit=${limit}&offset=${offset}`;
    console.log('🎯 Using condition 16 (no location, subcat only):', url);
  } else if (category && name && limit) {
    // No location — filter by category + name
    url = `/business/list/?category=${category}&name=${name}&limit=${limit}&offset=${offset}`;
    console.log('🎯 Using condition 17 (no location, cat+name):', url);
  } else if (category && limit) {
    // No location — filter by category only
    url = `/business/list/?category=${category}&limit=${limit}&offset=${offset}`;
    console.log('🎯 Using condition 18 (no location, cat only):', url);
  } else if (name && limit) {
    // No location — search by name only
    url = `/business/list/?name=${name}&limit=${limit}&offset=${offset}`;
    console.log('🎯 Using condition 19 (no location, name only):', url);
  } else if (limit) {
    // No location, no filters — get all businesses
    url = `/business/list/?limit=${limit}&offset=${offset}`;
    console.log('🎯 Using condition 20 (no location, no filters):', url);
  } else {
    console.log('❌ No conditions matched!');
  }

  console.log('🌐 Final URL:', url);
  // append is_pro if explicitly provided
  if (typeof is_pro !== 'undefined' && url) {
    url = url + `&is_pro=${is_pro}`;
  }

  const data = await DataService.getWithoutToken(url);

  return data?.data;
};

const getBookmark = async () => {
  let url = "/business/bookmarks/list/";
  const data = await DataService.get(url);
  return data?.data;
};

const addBookmark = async (id) => {
  let url = `/business/business/${id}/bookmark/`;
  const data = await DataService.post(url, {});
  return data?.data;
};

const getRating = async (id) => {
  let url = `/business/${id}/rating/`;
  const data = await DataService.get(url);
  return data?.data;
};

const updateRating = async (values) => {
  const { id } = values;
  let url = `/business/${id}/rating/`;
  const data = await DataService.patch(url, values);
  return data?.data;
};

const getDetails = async (id) => {
  let url = `/business/${id}/detail/`;
  const data = await DataService.getWithoutToken(url);
  return data?.data;
};

/* Opens a Razorpay order for one plan. Returns { amount, order_id, acc_key } —
   amount already in paise, acc_key is the publishable Razorpay key. */
const createSubscriptionTransaction = async ({ businessId, planId, amount }) => {
  let url = `/business/my_business/${businessId}/subscription/transaction/create/`;
  const data = await DataService.post(url, {
    subscription_plan: planId,
    amount,
    /* The model offers "offline" too, but only online payments can be
       completed without an admin entering the transaction by hand. */
    payment_type: "online",
  });
  return data?.data;
};

/* Hands Razorpay's three ids back to the server, which verifies the signature
   and captures the payment. Nothing may be treated as paid until this
   succeeds — the checkout callback alone proves nothing. */
const verifySubscriptionPayment = async (payload) => {
  let url = `/business/subscription/payment/verify/`;
  const data = await DataService.post(url, payload);
  return data?.data;
};

const getTrialplanDetails = async () => {
  let url = "/business/subscription/trial_plan/";
  const data = await DataService.get(url);
  return data?.data;
};
// const addViews = async (values) => {
//   let url = "/business/add_viewers/";
//   const data = await DataService.post(url, values);
//   return data?.data;
// };


const addViews = async (values) => {
  let url = "/business/add_viewers/";
  const data = await DataService.postWithoutToken(url, values);
  return data?.data;
};

const addHomeViews = async () => {
  let url = "/business/add_home_viewers/";
  const data = await DataService.postWithoutToken(url, {});
  return data?.data;
};

const getHomeViews = async () => {
  let url = "/business/home_viewers/";
  const data = await DataService.getWithoutToken(url);
  return data?.data;
};





const addCallers = async (values) => {
  let url = "/business/add_callers/";
  const data = await DataService.post(url, values);
  return data?.data;
};

const getCallCount = async (id) => {
  let url = `/business/${id}/call_count/`;
  const data = await DataService.getWithoutToken(url);
  return data?.data;
};

export {
  addBusiness,
  getMyBussiness,
  deleteBusiness,
  getSubcriptionPlan,
  getBusinessDetails,
  editBussiness,
  getBusinessList,
  getBookmark,
  addBookmark,
  getCurrentPlan,
  getRating,
  updateRating,
  getDetails,
  getTrialplanDetails,
  createSubscriptionTransaction,
  verifySubscriptionPayment,
  addViews,
  addHomeViews,
  getHomeViews,
  addCallers,
  getCallCount,
};
